/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react-hooks/rules-of-hooks */
import React, {useState, useEffect} from 'react';
import { Link, useLocation} from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ProductPage } from './ProductPage';
import { setProductsByCategory } from '../Store/Slices/ProductsSlice/ProductsSlice';

// getting current path
function getCurrentPath() {
  // getting full path
  const location = useLocation();
  const fullPath = location.pathname;
  // get first and second path
  const firstPath = fullPath.split('/')[1];
  const secondPath = fullPath.split('/')[2];
  const secondPathInNumber = Number(secondPath);
  return [firstPath, secondPathInNumber];
}

export const NotFound = ({setCategoryText}) => {
  // states
  const [paths] = useState(getCurrentPath());
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  setTimeout(()=>{
    setLoading(false);
  },1000)

  // fetch specific product or blog based on url
  const data = useSelector((state)=>state.products);
  const {products} = data; 
  const dispatch = useDispatch();
  useEffect(()=>{
    const filteredProducts = products.filter((product)=>product.category===paths[0]);
    const individualProduct = filteredProducts.filter((product)=>product.id===paths[1]);
    if(individualProduct.length>0){
      dispatch(setProductsByCategory(paths[0]));
      setProduct(individualProduct[0]);
    }
  },[]);

  return (
    <>
      {loading?(
        <div className='loading'>Please wait...</div>
      ):(
        <>
          {product?(
            <>
              <ProductPage productDirectHit={product} setCategoryText={setCategoryText} />
            </>
            ):(
              <div className='not-found-div'>
                <p>Page does not exist or has been deleted</p>
                <p style={{marginTop: 10+'px'}}>Return to <Link to="/">Home</Link></p>
              </div>
           )}
        </>
      )}
    </>
  )
}
